import request from '@/utils/request';
import {getFormData} from "@/utils/helpers";

const endpoints = {
    products: '/delivery/products',
    dedicatedProduct: id => `/delivery/product/${id}`
};

export default {
    getItems: async ({ dispatch, commit, state}, {page}) => {
        return request({
            url: endpoints.products,
            method: 'GET',
            params: {page, ...state.filters},
        }).then(res => {
            if (res.data) {
                commit('PROCESS_RES', res.data);
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, {root: true});
            }
        });
    },
    startPriceEditing({commit, state}, id) {
        commit('SET_ITEMS', state.items.map(i => {
            i.isEditingPrice = i.id === id;

            return i;
        }));
    },
    saveNewPrice({dispatch, state}, price) {
        const item = Object.assign(state.items.find(i => i.isEditingPrice === true), {price});

        return request({
            url: endpoints.dedicatedProduct(item.id),
            method: 'PUT',
            data: getFormData({price: item.price})
        }).then(res => {
            if (res.data) {
                dispatch('getItems', {page: state.pagination.page});
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, {root: true});
            }
        });
    },
    toggleAvailability({dispatch, state}, {newStatus, productId}) {
        return request({
            url: endpoints.dedicatedProduct(productId),
            method: 'PUT',
            data: getFormData({status: newStatus})
        }).then(res => {
            if (res.data) {
                dispatch('getItems', {page: state.pagination.page});
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, {root: true});
            }
        });
    }
};
